require('script-loader!./lib/jasmine/jasmine');
require('script-loader!./lib/jasmine/jasmine-html');
var _ = require('underscore');
var Jasmine = require('jasmine-boot');
var Marionette = require('marionette');

var TestType = {
    functional: 1,
    unit: 2
};

var Layout = Marionette.View.extend({
    regions: {
        test: '#test'
    },
    template: '#testBenchLayoutTemplate'
});

var View = Marionette.View.extend({
    events: {
        'click a': 'anchor'
    },
    template: '#testBenchTemplate',
    anchor: function (e) {
        e.preventDefault();
    }
});

var functional = function (options) {
    require('testSpecs/Functional/RecordActionApprove').describe(options);
};

var unit = function (options) {
    require('testSpecs/Unit/Dropdown').describe(options);
};

var render = function (fn, options) {
    var consultation = require('Consultation');
    var mock = require('Consultation');
    var layout = new Layout();
    var view = new View();
    var env = {};

    consultation.show({ view: layout });
    layout.getRegion('test').show(view);
    env = Jasmine.env({ container: view.el });
    describe('Consultation Record', function () {
        var mainApplication = consultation.application;
        var mainLayout = consultation.layout;

        beforeAll(function (done) {
            mock.start({ container: '#consultationInTest', history: false });

            setTimeout(function () {
                done();
            }, 100);
        });

        afterAll(function (done) {
            consultation.application = mainApplication;
            consultation.layout = mainLayout;
            done();
        });

        fn(options);
    });

    env.execute();
};

module.exports.run = function (options) {
    var type = +options.type;
    var env = {};

    switch (type) {
        case TestType.functional:
            render(functional, {});
            break;
        case TestType.unit:
            render(unit, {});
            break;
    }
};


// WEBPACK FOOTER //
// ./test/TestBench.js